import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react'

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const testimonials = [
    {
      name: 'Dr. Sarah Johnson',
      role: 'Chief Radiologist',
      hospital: 'Memorial Medical Center',
      content: 'The ultrasound systems from South Hampton Medical Imaging have revolutionized our diagnostic capabilities. The image quality is exceptional and the user interface is intuitive.',
      rating: 5,
      avatar: 'SJ'
    },
    {
      name: 'Dr. Michael Chen',
      role: 'Cardiologist',
      hospital: 'Heart & Vascular Institute',
      content: 'We\'ve seen a 40% improvement in diagnostic accuracy since implementing their cardiac ultrasound systems. The 3D imaging capabilities are game-changing.',
      rating: 5,
      avatar: 'MC'
    },
    {
      name: 'Dr. Emily Rodriguez',
      role: 'Obstetrician',
      hospital: 'Women\'s Health Center',
      content: 'The obstetric ultrasound equipment provides crystal-clear images that help us provide better care for our patients. The support team is always responsive.',
      rating: 5,
      avatar: 'ER'
    },
    {
      name: 'Dr. James Wilson',
      role: 'Emergency Medicine',
      hospital: 'City General Hospital',
      content: 'In emergency situations, we need reliable equipment that works every time. South Hampton Medical Imaging\'s systems have never let us down, even in the most critical moments.',
      rating: 5,
      avatar: 'JW'
    },
    {
      name: 'Dr. Lisa Thompson',
      role: 'Neurologist',
      hospital: 'Neurological Institute',
      content: 'The transcranial Doppler capabilities are outstanding. We can now perform non-invasive brain imaging with incredible precision and detail.',
      rating: 5,
      avatar: 'LT'
    }
  ]

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length)
  }

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)
  }

  return null
  // return (
  //   <section className="section-padding bg-white">
  //     <div className="container-custom">
  //       <motion.div
  //         ref={ref}
  //         initial={{ opacity: 0, y: 50 }}
  //         animate={inView ? { opacity: 1, y: 0 } : {}}
  //         transition={{ duration: 0.8 }}
  //         className="text-center mb-16"
  //       >
  //         <div className="inline-flex items-center px-4 py-2 bg-primary-50 text-primary-700 rounded-full text-sm font-medium mb-6">
  //           <span className="w-2 h-2 bg-primary-500 rounded-full mr-2"></span>
  //           Testimonials
  //         </div>
  //         <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
  //           What Our Clients Say
  //         </h2>
  //         <p className="text-xl text-gray-600 max-w-3xl mx-auto">
  //           Hear from healthcare professionals who trust our technology for their diagnostic needs.
  //         </p>
  //       </motion.div>

  //       <motion.div
  //         initial={{ opacity: 0, y: 50 }}
  //         animate={inView ? { opacity: 1, y: 0 } : {}}
  //         transition={{ duration: 0.8, delay: 0.2 }}
  //         className="max-w-4xl mx-auto"
  //       >
  //         <div className="bg-gradient-to-br from-primary-50 to-accent-50 rounded-3xl p-8 md:p-12 relative">
  //           <Quote className="absolute top-8 left-8 w-12 h-12 text-primary-200" />
            
  //           <div className="text-center">
  //             {/* Rating */}
  //             <div className="flex justify-center mb-6">
  //               {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
  //                 <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
  //               ))}
  //             </div>

  //             {/* Testimonial content */}
  //             <blockquote className="text-xl md:text-2xl text-gray-700 mb-8 italic">
  //               "{testimonials[currentIndex].content}"
  //             </blockquote>

  //             {/* Author info */}
  //             <div className="flex items-center justify-center space-x-4">
  //               <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
  //                 {testimonials[currentIndex].avatar}
  //               </div>
  //               <div className="text-left">
  //                 <div className="font-semibold text-gray-900">
  //                   {testimonials[currentIndex].name}
  //                 </div>
  //                 <div className="text-primary-600">
  //                   {testimonials[currentIndex].role}
  //                 </div>
  //                 <div className="text-sm text-gray-600">
  //                   {testimonials[currentIndex].hospital}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           {/* Navigation buttons */}
  //           <div className="flex justify-between items-center mt-8">
  //             <button
  //               onClick={prevTestimonial}
  //               className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-all duration-200 group"
  //             >
  //               <ChevronLeft className="w-6 h-6 text-gray-600 group-hover:text-primary-600" />
  //             </button>

  //             {/* Dots indicator */}
  //             <div className="flex space-x-2">
  //               {testimonials.map((_, index) => (
  //                 <button
  //                     key={index}
  //                     onClick={() => setCurrentIndex(index)}
  //                     className={`w-3 h-3 rounded-full transition-all duration-200 ${
  //                       index === currentIndex 
  //                         ? 'bg-primary-600 w-8' 
  //                         : 'bg-gray-300 hover:bg-gray-400'
  //                     }`}
  //                   />
  //                 ))}
  //               </div>

  //               <button
  //                 onClick={nextTestimonial}
  //                 className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-all duration-200 group"
  //               >
  //                 <ChevronRight className="w-6 h-6 text-gray-600 group-hover:text-primary-600" />
  //               </button>
  //             </div>
  //           </div>
  //         </motion.div>
  //       </div>
  //     </section>
  //   )
}

export default TestimonialsSection 